import groq from 'groq'

export function videoAsset() {
	return groq`
        {
            "type": "video",
            ...sources[0].source.asset->{
                "mediaType": contentType,
                "width": dimensions.width,
                "height": dimensions.height,
            },
            sources[]{
                ...source.asset->{
                    "url": fileURL,
                    "width": dimensions.width,
                    "height": dimensions.height,
                    "type": contentType,
                }
            },
            "caption": options.caption,
            "muted": coalesce(options.muted, true),
            "loop": coalesce(options.loop, true)
        }
    `
}
